require("./loader.js");
require("./game.js");
require("./gameController.js");
require("./ui/settingsMenu.js");
require("./ui/BPsettingsMenuButton.js");
require("./freespinsIntro.js");
require("./freespins.js");
require("./pixi-spine.js");
require("./spine.js");
require("./particleManager.js");
require("./winlineAnimator.js");
require("./colourBox.js");
require("./screenDimObject.js");
require("./bigWin.js");
require("../../node_modules/hammerjs/hammer.min.js");
require("./musicManager.js");
require("./goldenBetToggle.js");
require("./decreaseStakeButton.js");
require("./increaseStakeButton.js");
require("./hbcVolumeButton.js");
require("./ui/gameStakeSelection.js");
require("./ui/BPautoplayManager-ext.js");
require("./ui/BPgameHistoryButton.js");
require("./ui/sideMenu.js");
require("./ui/BPsideMenuButton.js");
require("./ui/settingSound.js");
require("./featureOutroPopup.js");
require("./ui/BPgameRulesStringButton.js");
require("./ui/BPfullscreenButton.js");
require("./ReelSpinnerVisualSCS.js");
require("./ReelSpinnerVisualStacked.js");
require("./winAnimations/movieSymbolAnimator.js");
require("./winAnimations/wildFireballSymbolAnimator.js");
require("./winAnimations/SymbolLandAnimator.js");
require("./winAnimations/fireballLandSymbolAnimator.js");
require("./shaker.js");
require("./ui/buyBonusButton.js");
require("./ui/buyBonusPopup.js");
require("./ui/GameSlamStopButton.js");
require("./ui/skipWinsButton.js");
require("./ui/BPoptionsButtonEx.js");
require("./wildFireAnim.js");
require("./fireballAnimation.js");
require("./potBonus.js");
require("./potBonusIntroAnim.js");
require("./freespinsFireSlot.js");
require("./firelinkFeature.js");
require("./freespinsFireSlotManager.js");
require("./freespinsRetriggerPopup.js");
require("./reelFireball.js");
require("./fireBallIntro.js");
require("./WinController.js");
require("./fancyGroupRules.js");
require("./ScrollContainer.js");
require("../../node_modules/reflex_libs/src/lib/gsap.min.js");
require("../../node_modules/reflex_libs/src/lib/gsapPixiPlugin.js");
